import * as React from 'react';

interface CheckboxProps extends Omit<React.ComponentProps<'input'>, 'onChange'> {
  label?: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  disabled?: boolean;
}

export const Checkbox = ({ label, isChecked, onChange, ...props }: CheckboxProps) => {
  return (
    <label className="flex items-center space-x-2 cursor-pointer">
      <input
        type="checkbox"
        className="form-checkbox h-5 w-5 bg-primary"
        onChange={() => onChange(!isChecked)}
        checked={isChecked}
        {...props}
      />
      {label ? <span className="text-gray-700">{label}</span> : null}
    </label>
  );
};
